import { useMediaQuery } from 'react-responsive'

export default ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: 768 })
  return isNotMobile ? children : null
}
